import { render } from "./AddEditProduct.vue?vue&type=template&id=5a048abe"
import script from "./AddEditProduct.vue?vue&type=script&lang=js"
export * from "./AddEditProduct.vue?vue&type=script&lang=js"

import "./AddEditProduct.vue?vue&type=style&index=0&id=5a048abe&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__